export default "__VITE_ASSET__DRNkEPHU__";